export default __webpack_public_path__ + "static/media/delete-span.e6ff10f3.gif";